import React, { useState, useEffect } from "react";
import { Formik, Form } from "formik";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import ButtonContained from "../button";
import DropdownComp from "../dropdown";
import Input from "../input";
import { AddMasterProductSchema } from "../../validation/ValidationSchema";
import { api } from "../../api";

import { toast } from "react-toastify";

// import AddDenominationRow from '../../../../components/addDenominationRow/AddDenominationRow';

const AddProduct = () => {
  const token = useSelector((state) => state.auth.token);
  const region = useSelector((state) => state.auth.region);

  console.log(region);

  // eslint-disable-next-line
  const { userType: role } = useSelector((state) => state.auth.user);
  const navigate = useNavigate();
  const [productDataList, setProductDataList] = useState([
    { value: "", label: "please select" },
  ]);
  // eslint-disable-next-line no-unused-vars
  const [data, setData] = useState({});
  // eslint-disable-next-line no-unused-vars
  const getFiles1 = (files) => {
    setData(files);
  };

  const productList = productDataList.length
    ? productDataList
    : [{ value: "", label: "please select" }];

  const options = productList;

  const [masterDataList, setMasterDataList] = useState([
    { value: "", label: "please select" },
  ]);

  const masterList = masterDataList.length
    ? masterDataList
    : [{ value: "", label: "please select" }];

  // eslint-disable-next-line no-unused-vars
  const masterptions = masterList;

  //loading
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    api.products.getMasterData({}, token).then((res) => {
      var masterList = [];
      if (res.code === 200) {
        for (let i of res.data.result) {
          masterList.push({ value: i.masterProdId, label: i.masterProdName });
        }
        setMasterDataList(masterList);
      }
    });
  }, [token]);

  useEffect(() => {
    api.brands.getBrandList({}, token).then((res) => {
      var productList = [];
      if (res.code === 200) {
        for (let i of res.data.result) {
          productList.push({ value: i.brandId, label: i.brandName });
        }
        setProductDataList(productList);
      }
    });
  }, [token]);

  if (isLoading) {
    return <div> Loading... </div>;
  }

  return (
    <Formik
      validationSchema={AddMasterProductSchema}
      initialValues={{
        brandId: "",
        name: "",
        price: "",
        margin: "",
        thresholdValue: "",
        denomination: "",
        reseller_region_id: "",
        // eslint-disable-next-line
        resellerType: region.name || "",
        currency: region.currency || "",
        isDevco: false,
      }}
      enableReinitialize
      onSubmit={(values, { resetForm }) => {
        setIsLoading(true);
        const formBody = {
          brandId: values.brandId && values.brandId.value,
          name: values.name,
          price: values.price,
          margin: values.margin,
          thresholdValue: values.thresholdValue,
          denomination: values.denomination,
          reseller_region_id: region.id,
          isDevco: values.isDevco,
        };

        api.products
          .createMaster(formBody, token)
          .then((res) => {
            if (res.code === 200) {
              resetForm();
              setIsLoading(false);
              toast.success(res.message);
              navigate("/master");
            } else {
              resetForm();
              setIsLoading(false);
              toast.error(res.message);
            }
          })
          .catch((err) => {
            // resetForm()
            // setIsLoading(false)
            toast.error("!Oops, Something went wrong", "error");
          });
      }}
    >
      {({
        handleSubmit,
        handleChange,
        handleBlur,
        values,
        touched,
        isValid,
        errors,
        isSubmitting,
        setFieldValue,
      }) => {
        return (
          <div className="container-fluid">
            <div className="row">
              <div className="col-sm-12">
                <div className="box-row">
                  <div className="table-head">
                    <h1 className="sec-header">ADD MASTER PRODUCT </h1>
                  </div>
                  <div className="card card-table">
                    {/* <div className="card-header card-header-title"> Master Product Details
                                             
                                        </div> */}
                    <div className="card-body gatepass-saveoutput">
                      <div className="reports">
                        <Form onSubmit={handleSubmit}>
                          <div className="form-row">
                            <div className="form-group col-md-4">
                              <Input
                                name="resellerType"
                                id="resellerType"
                                label="Reseller Region"
                                placeholder="Reseller Region"
                                type="text"
                                value={values.resellerType}
                                disabled={true}
                              />
                            </div>
                            <div className="form-group col-md-4">
                              <Input
                                name="currency"
                                id="currency"
                                label="Currency"
                                placeholder="Currency"
                                type="text"
                                value={values.currency}
                                disabled={true}
                              />
                            </div>
                            <div className="form-group col-md-4">
                              <DropdownComp
                                id="brandId"
                                name="brandId"
                                onChange={(selectedValue) => {
                                  setFieldValue("brandId", selectedValue);
                                }}
                                value={values.brandId}
                                options={options}
                                label="Brand Name"
                                placeholder="Brand"
                                error={touched.brandId && errors.brandId}
                                errorText={errors.brandId}
                                disabled={isSubmitting}
                              />
                            </div>
                          </div>

                          <div className="form-row">
                            <div className="form-group col-md-4">
                              <Input
                                id="name"
                                name="name"
                                placeholder="Master Product Name"
                                type="text"
                                label="Master Product Name"
                                value={values.name}
                                onChange={handleChange}
                                error={touched.name && errors.name}
                                errorText={errors.name}
                                disabled={isSubmitting}
                              />
                              {/* <DropdownComp
                                                                id="name"
                                                                name="name"
                                                                placeholder="Master product Name"
                                                                label="Master Product Name"
                                                                value={values.name}
                                                                // isMulti
                                                                onChange={(selectedValue) => {
                                                                setFieldValue("name", selectedValue);
                                                                }}
                                                                options={masterptions}
                                                                error={touched.name && errors.name}
                                                                errorText={errors.name}
                                                                disabled={isSubmitting}
                                                            /> */}
                            </div>

                            <div className="form-group col-md-4">
                              <Input
                                id="price"
                                name="price"
                                placeholder="price"
                                type="text"
                                label="Price"
                                value={values.price}
                                onChange={handleChange}
                                error={touched.price && errors.price}
                                errorText={errors.price}
                                disabled={isSubmitting}
                              />
                            </div>

                            <div className="form-group col-md-4">
                              <Input
                                id="margin"
                                name="margin"
                                placeholder="Nodwin Margin"
                                type="number"
                                label="Nodwin Margin"
                                value={values.margin}
                                onChange={handleChange}
                                error={touched.margin && errors.margin}
                                errorText={errors.margin}
                                percentage={true}
                                disabled={isSubmitting}
                              />
                            </div>

                            <div className="form-group col-md-4">
                              <Input
                                id="denomination"
                                name="denomination"
                                placeholder="Product Denomination"
                                type="text"
                                label="Product Denomination"
                                value={values.denomination}
                                onChange={handleChange}
                                error={
                                  touched.denomination && errors.denomination
                                }
                                errorText={errors.denomination}
                                disabled={isSubmitting}
                              />
                            </div>

                            <div className="form-group col-md-4">
                              <Input
                                id="thresholdValue"
                                name="thresholdValue"
                                placeholder="Minimum Quantity"
                                type="number"
                                label="Minimum Quantity"
                                value={values.thresholdValue}
                                onChange={handleChange}
                                error={
                                  touched.thresholdValue &&
                                  errors.thresholdValue
                                }
                                errorText={errors.thresholdValue}
                                disabled={isSubmitting}
                              />
                            </div>
                          </div>

                          {region.currency === "USD" && (
                            <div className="form-row">
                              <div className="form-group col-md-6">
                                <label className="form-label">
                                  Product Source
                                </label>
                                <div className="form-check">
                                  <input
                                    type="checkbox"
                                    className="form-check-input"
                                    id="isDevco"
                                    name="isDevco"
                                    checked={values.isDevco}
                                    onChange={handleChange}
                                    disabled={isSubmitting}
                                  />
                                  <label
                                    className="form-check-label"
                                    htmlFor="isDevco"
                                  >
                                    Devco
                                  </label>
                                  <small className="form-text text-muted">
                                    Check this if the product will be purchased
                                    from Devco
                                  </small>
                                </div>
                              </div>
                            </div>
                          )}
                          <br />

                          <ButtonContained
                            buttonName="Save"
                            disabled={isSubmitting}
                          />
                        </Form>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        );
      }}
    </Formik>
  );
};

export default AddProduct;
